var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVicDots = function SvgVicDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 124,
    height: 108,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M10.12 19.77a9.55 9.55 0 0 0 9.55-9.55 9.55 9.55 0 1 0-9.55 9.55M73.15 104.21a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M83.15 97.21a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6EE4FF",
    d: "M91.93 107.03a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M113.93 101.03a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1M41.19 96.66a9.55 9.55 0 1 0 0-19.1 9.55 9.55 0 0 0 0 19.1"
  })));
};
export default SvgVicDots;